// Copyright (c) 2023-2024 Broadcom. All Rights Reserved.
// Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
// and/or its subsidiaries.

import { Injectable } from "@angular/core";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { L10nService } from "@vmw/ngx-vip";
import { ConsoleStrings } from "@shared/models/strings.model";
import { AppConfigService } from "@app/services/app-config/app-config.service";

// @formatter:off
@Injectable({
    providedIn: "root"
})
// @formatter:on
export class LocalizedTitleStrategy extends TitleStrategy {
    constructor(private readonly title: Title,
                private appConfig: AppConfigService,
                private l10nService: L10nService) {
        super();
    }

    updateTitle(routerState: RouterStateSnapshot): void {
        const title = this.buildTitle(routerState);
        const consoleStrings: ConsoleStrings = this.appConfig.getConsoleStrings();
        let localizedTitle: string;
        if (title !== undefined) {
            localizedTitle = this.l10nService.getMessage(title);
            const formattedTitle = this.l10nService.getMessage(consoleStrings.htmlTitle, [localizedTitle]);
            this.title.setTitle(formattedTitle);
        } else {
            localizedTitle = this.l10nService.getMessage(consoleStrings.htmlTitleDefault);
            this.title.setTitle(localizedTitle);
        }
    }

}
